import { plainToInstance, Type } from 'class-transformer'
import { ISiteBoxDocumentPdfVersion } from '@core/entities/SiteBoxDocumentPdfVersion'
import { ProjectPlanArea } from '@core/entities/project/ProjectPlanArea'
import { Entity } from '@core/entities/entity'
import { ProjectPlanStatus } from '@core/entities/project/ProjectPlan'
import { ISiteBoxPlanDocument } from '@core/entities/SiteBoxPlanDocument'
import { SiteBoxPlanDocument } from '@core/entities/SiteBoxPlanDocument'

export class SiteBoxDocumentPlan extends Entity<ISiteBoxPlanDocument> {
  id: number

  areas: ProjectPlanArea[]

  @Type(() => SiteBoxPlanDocument)
  siteBoxPlanDocument: SiteBoxPlanDocument

  status: ProjectPlanStatus

  public static new(payload: ISiteBoxDocumentPdfVersion) {
    const entity = plainToInstance(SiteBoxDocumentPlan, payload)

    return entity
  }
}
